import { InteractivityProfile } from 'logi-embed';
import { ApplyFiltersStrategy } from 'logi-embed/EmbeddedDashboard';
export const TOKEN_ENDPOINT = '/api/authz/user/logi-access-token';
export const formatDateRangeForLogiFiltering = ({ startDate, endDate }, prefix) => ([
    `${prefix || ''}${startDate} 00:00:00.000`,
    `${prefix || ''}${endDate} 23:59:59.999`,
]);
export const getLogiComponentKey = (config) => {
    const dashboardId = config.dashboardId || '';
    const idForEnvironment = dashboardId;
    return idForEnvironment || 'no-token';
};
// Converts basic info from our own type LogiComponentConfiguration to the Logi type DashboardComponentConfiguration
// Determines dashboard and source IDs based on environment
// Formats date range and sets in initial filters
export const buildLogiDashboardComponentConfig = (config, dateRange, environment) => {
    // Default to nonprod for any unrecognized environment
    const environmentKey = environment === 'prod' ? 'prod' : 'nonprod';
    // const [dateFrom, dateTo] = formatDateRangeForLogiFiltering(dateRange);
    const { dashboardId } = config;
    const sourceId = (config.sourceId || {})[environmentKey];
    const includeInitialFilters = sourceId && config.dateField;
    return {
        dashboardId,
        header: {
            showActions: false,
        },
        interactivityProfileName: InteractivityProfile.READ_ONLY,
        interactivityOverrides: {
            settings: {
                FILTER: false,
            },
            visualSettings: {
                TIMEBAR_PANEL: false,
            },
        },
        // This property will filter the dashboard by the date range from redux on initial load
        // Allowing for deep linking and to keep our own date picker
        // Only enabled if sourceId and date field are provided in the config
        ...(includeInitialFilters ? {
            initialFilters: {
                sourceId,
                filters: [
                // {
                //     operation: 'BETWEEN',
                //     // Right now we are only worried about one dashboard (the one found hardcoded in LogiView).
                //     // For this dashboard we have to set the path to lowercase "ro_date"
                //     // to get the date to be filtered correctly on initial page load
                //     // However, when UPDATING the date via the date picker using the publishFilters function,
                //     // we have to use "RO_DATE" and not "ro_date" or the filter won't apply
                //     // That's because the lowercase ro_date is the SNOWFLAKE COLUMN whereas RO_DATE is a manually
                //     // applied filter we created.
                //     // Why does initial filtering vs published filtering require different paths? I have no idea.
                //   // All this to say, we will not keep this line as-is for long. We will probably require another
                //     // option in the config rather than lowercasing the date field for all initial filters
                //     path: (config.dateField || '').toLowerCase(),
                //     value: [dateFrom, dateTo],
                // },
                ],
                applyFiltersStrategy: ApplyFiltersStrategy.REPLACE_EXISTING,
                // Turns out, the timeFilter doesn't work if you have disabled the time bar
                // ... you instead have to use filters[] as shown above
                // It does need to be included in the config because type DashboardComponentConfiguration requires it
                timeFilter: {
                    timeField: '',
                    from: '',
                    to: '',
                },
            },
        } : {}),
    };
};
